module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/alizee.d522920.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/alizee.jpg
// module id = 0Bd9
// module chunks = 0